{
  "pipeData": {
    "bm.billing.customer.billing.account.dunning.ql": {
      "data": [
        {
          "customerId": 10001,
          "customerBillingAccountId": 20001,
          "dunningId": 30001,
          "transactionAmount": 250,
          "contracts": [
            {
              "identifier": "82889292",
              "partner": "Allianz",
              "type": "Health Insurance",
              "monthlyPrice": [
                {
                  "startMonth": "2024-01",
                  "monthlyPrice": 37.22
                }
              ],
              "currency": "EUR",
              "dunningMonths": 3,
              "reactivationMonths": 5,
              "dunningAmount": 111.66,
              "reactivationAmount": 186.1,
              "status": "in-dunning"
            },
            {
              "identifier": "82889293",
              "partner": "DKV",
              "type": "Dental Insurance",
              "monthlyPrice": [
                {
                  "startMonth": "2024-01",
                  "monthlyPrice": 7.31
                }
              ],
              "currency": "EUR",
              "dunningMonths": 3,
              "reactivationMonths": 5,
              "dunningAmount": 21.93,
              "reactivationAmount": 37.55,
              "status": "in-dunning"
            },
            {
              "identifier": "82889294",
              "partner": "Gothaer",
              "type": "Life Insurance",
              "monthlyPrice": [
                {
                  "startMonth": "2024-01",
                  "monthlyPrice": 4.73
                }
              ],
              "currency": "EUR",
              "dunningMonths": 3,
              "reactivationMonths": 5,
              "dunningAmount": 14.19,
              "reactivationAmount": 23.65,
              "status": "in-dunning"
            },
            {
              "identifier": "82889295",
              "partner": "Axa",
              "type": "Accident Insurance",
              "monthlyPrice": [
                {
                  "startMonth": "2026-01",
                  "monthlyPrice": 10.0
                }
              ],
              "currency": "EUR",
              "dunningMonths": 0,
              "reactivationMonths": 0,
              "dunningAmount": 0,
              "reactivationAmount": 0,
              "status": "new"
            }
          ],
          "charges": [
            {
              "name": "Lawyer Fees",
              "amount": 80.0,
              "currency": "EUR",
              "deductable": true,
              "reducable": true
            },
            {
              "name": "Court Fees",
              "amount": 150.00,
              "currency": "EUR",
              "deductable": false,
              "reducable": false
            },
            {
              "name": "Administrative Fees",
              "amount": 50.00,
              "currency": "EUR",
              "deductable": true,
              "reducable": true
            },
            {
              "name": "Collection Agency Fees",
              "amount": 120.00,
              "currency": "EUR",
              "deductable": false,
              "reducable": true
            }
          ]
        }


      ],
      "form": null,
      "info": null,
      "metrics": null,
      "messages": []
    }
  },
  "executionRuntime": 10
}